import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlertTriangle = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 80 80",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M40 43.0001V28.0483",
			strokeWidth: 4,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40 54.0826V54.214",
			strokeWidth: 4,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M58.8998 66.6667H21.1002C15.937 66.6667 11.5797 63.2543 10.2088 58.5857C9.62364 56.5928 10.3427 54.517 11.4425 52.7497L30.3423 18.6701C34.7703 11.5545 45.2297 11.5545 49.6577 18.6701L68.5575 52.7497C69.6573 54.517 70.3764 56.5928 69.7912 58.5857C68.4203 63.2543 64.063 66.6667 58.8998 66.6667Z",
			strokeWidth: 4,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgAlertTriangle;
